import { AUTH_LOADING, type AuthPendingAction } from '../constants/auth'

export function authSubmitLabel(
  pending: AuthPendingAction,
  fallback: string,
): string {
  if (pending === 'otp-request') return AUTH_LOADING.sendingOtp
  if (pending === 'otp-verify') return AUTH_LOADING.verifyingOtp
  if (pending === 'google') return AUTH_LOADING.google
  return fallback
}
